<template>
	<LayoutBase>
		<template v-if="!$wait.is('fetching preview resource')">
			<section class="preview-section">
				<header class="preview-section__header">
					<h2 class="h1">Intelligence</h2>
					<router-link :to="{ name: 'edit-intelligence', params: { intelligence_id: resource.id }}" class="btn">Edit</router-link>
				</header>
				<div v-if="resource.creator" class="profile-list">
					<p class="profile-list__title">Lead User</p>

					<UserCard :user="resource.creator" :borderless="true"></UserCard>
				</div>
				<hr/>
				<ul class="grid post-details">
					<li v-if="resource.dealType" class="col-3 detail">
						<span class="label">Deal Type</span>
						<span class="h3"><SvgIcon :icon="'deal'" /> {{ resource.dealType }}</span>
					</li>
					<li v-if="resource.sectors" class="col-9 detail">
						<span class="label">Sectors</span>
						<span class="sector" v-for="sector in resource.sectors">{{ sector.name }}</span>
					</li>
				</ul>
				<div class="card" v-if="resource.content">
					<div class="header">Intel</div>
					<div v-html="resource.content"></div>
				</div>
				<div class="form">
					<div class="form__group form__group--submit-fixed">
						<button @click="showDeleteModal()" class="btn btn--danger" v-if="resource.can.delete"
						        v-wait:disabled="['saving preview resource', 'deleting preview resource']">
							Delete Intelligence
						</button>
						<router-link tag="button"
						             :to="{ name: 'view-intelligence', params: { intelligence_id: resource.id }}"
						             class="btn" v-wait:disabled="'saving preview resource'">
							Save and Leave
						</router-link>
						<button @click="saveResource(2)" class="btn btn--primary btn--no-stretch"
						        v-wait:disabled="'saving preview resource'" v-if="resource.can.submit">
							Post Intelligence
						</button>
					</div>
				</div>
			</section>
		</template>
	</LayoutBase>
</template>

<script>
	import LayoutBase from '../Layout/LayoutBase';
	import API from '../../api';
	import SvgIcon from '../SvgIcon';
	import ResourcePreview from '../ResourcePreview';
	import UserCard from '../User/UserCard';

	export default {
		name: 'IntelligencePreview',
		mixins: [ResourcePreview],
		components: {
			UserCard,
			LayoutBase,
			SvgIcon,
		},
		data() {
			return {
				deleteModal: {
					title: 'Are you sure you want to delete this Intelligence?',
					buttonLabel: 'Delete Intelligence',
				},
			};
		},
		methods: {
			fetchResource() {
				return API.getIntelligence(this.id);
			},
			updateResource(status) {
				return API.updateIntelligence(this.id, {status: status}).then(() => {
					this.$router.push({
						name: 'view-intelligence',
						intelligence_id: this.id,
					});
				});
			},
			deleteResource() {
				return API.deleteIntelligence(this.id).then(() => {
					this.$router.push({ name: 'intelligence' });
				});
			},
		},
	}
</script>

<style lang="scss" scoped>
	hr {
		margin: 6rem 0 4rem;
	}

	.post-details {
		margin-bottom: 3rem;
	}
</style>
